/**
 * ExpandPanelIcon — A panel with its side pane and an arrow out: the panel takes more room.
 * Hugeicons panel-right-close (MIT).
 */

import svg from './svg/expand-panel.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const ExpandPanelIcon = makeSvgIcon('expand-panel', svg);
